<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
	<g clip-path="url(#clip0_10110_2183)">
	<path d="M8.00004 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00004 1.33331C4.31814 1.33331 1.33337 4.31808 1.33337 7.99998C1.33337 11.6819 4.31814 14.6666 8.00004 14.6666Z" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M5.33337 9.33331C5.33337 9.33331 6.33337 10.6666 8.00004 10.6666C9.66671 10.6666 10.6667 9.33331 10.6667 9.33331" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M10 6H10.0067" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M6 6H6.00667" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
	<defs>
	<clipPath id="clip0_10110_2183">
	<rect width="16" height="16" fill="white"/>
	</clipPath>
	</defs>
	</svg>